var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 8.6669H20.2833C19.9924 7.89596 19.5404 7.19596 18.9575 6.61357L16.0542 3.70858C15.4711 3.12635 14.7709 2.67467 14 2.38358V7.83358C14 8.29377 14.3731 8.6669 14.8333 8.6669Z",
    fill: "#382E6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6466 10.3333H14.8333C13.4526 10.3333 12.3333 9.21402 12.3333 7.83332V2.02C12.1991 2.01082 12.065 2 11.9291 2H8.16664C5.8666 2.00277 4.00273 3.86664 4 6.16668V17.8334C4.00273 20.1334 5.8666 21.9973 8.16664 22H16.5C18.8 21.9973 20.6639 20.1334 20.6666 17.8333V10.7375C20.6666 10.6017 20.6558 10.4675 20.6466 10.3333Z",
    fill: "#382E6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.f2290adb49fa6bcbbd0c1d7c46019199.svg";
export { ForwardRef as ReactComponent };